// Cart drawer: the add-a-pack buttons under the free shipping and saving line (snippets/bl-cart-tiers.liquid).
// Adds one 8-pack of that colour and lets the theme redraw the cart from the sections it returns.
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-bl-quick-add]');
  if (!b || b.getAttribute('aria-busy') === 'true') return;
  e.preventDefault();
  b.setAttribute('aria-busy', 'true');
  const id = Number(b.dataset.blQuickAdd);
  const body = { items: [{ id, quantity: 1 }] };
  const sections = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId).filter(Boolean);
  if (sections.length) body.sections = sections.join(',');
  const url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  try {
    const res = await fetch(url, {
      method: 'POST', body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const json = await res.json();
    if (json.status) { b.title = json.description || json.message || ''; return; }
    try {
      const { CartAddEvent } = await import('@theme/events');
      document.dispatchEvent(new CartAddEvent({}, String(id), {
        source: 'bl-cart', itemCount: 1, productId: String(b.dataset.blProduct || ''), sections: json.sections,
      }));
    } catch (err) {
      window.location.reload();
    }
  } catch (err) {
    window.location.href = '/cart';
  } finally {
    b.removeAttribute('aria-busy');
  }
});
